import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { LimitExceptionsUploadResponse } from '@/models/limit-exceptions-upload/limit-exceptions-upload.model';

export default class UploadLimitExceptionsRequest extends ApiResourceMethod<LimitExceptionsUploadResponse> {
  public perform(data: FormData): Promise<LimitExceptionsUploadResponse> {
    return this.performer.requestWithMapper(
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
      },
      ({ data }: BaseResponse<LimitExceptionsUploadResponse>): LimitExceptionsUploadResponse => data,
    );
  }
}
